import { OpeningApprovalsService } from 'api-clients/monolith';
import { useCallback } from 'react';

import { useApiService } from './useApiService';

/**
 * Fetches opening approval approver groups for a given opening ID.
 *
 * @param openingId - The opening ID to get the approver groups for.
 * @returns { approverGroups, ...rest } - The first page of approver groups and the useApiService result helpers.
 */
export function useOpeningApprovalApproverGroupsForOpening(openingId: string) {
  const fetchApproverGroups = useCallback(
    () =>
      OpeningApprovalsService.getInternalApiOpeningApprovalApproverGroupsApproverGroupsForOpening(
        openingId,
      ),
    [openingId],
  );

  const { result, ...rest } = useApiService(fetchApproverGroups);

  const approverGroups =
    result.status === 'ready' ? result.data.approver_groups : undefined;

  return { approverGroups, ...rest };
}
